<template>
    <div class="container base-height" v-e2e="'formulario-tarefa-a-concluir-page'">
        <div class="columns base-height">
            <div class="column is-half base-height py-0">
                <div class="is-flex is-flex-direction-column base-height">
                    <div style="max-width:calc(100vw / 4);min-width: 320px;">
                        <img :src="logoSrc" alt="logo" />
                    </div>
                    <div class="box-texto is-flex is-flex-direction-column is-justify-content-center is-flex-grow-1" style="margin-top:-4rem">
                        <div v-e2e="'formulario-tarefa-a-concluir-titulo'">
                            <h1 class="is-size-3">Informações salvas com sucesso!</h1>
                        </div>
                        <hr class="mt-3 mb-4" />
                        <br/>
                        <div v-e2e="'formulario-tarefa-a-concluir-mensagem'">
                            <p>Se precisar continuar preenchendo os dados, basta acessar o formulário pelo link novamente.</p>
                        </div>
                        <br>
                        <div v-e2e="'formulario-tarefa-a-concluir-link'">
                            <a class="custom-link" :href="previousUrl">Voltar ao formulário</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="column is-half py-0">
                <div class="is-flex base-height is-justify-content-center is-align-items-center">
                    <img src="/img/form_a_concluir.png" alt="logo" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrfFormAConcluir",
    data() {
        const rawUrl = decodeURIComponent(this.$route.query.previousUrl || '');
        const isUrlSegura = (rawUrl.startsWith('/') && !rawUrl.startsWith('//')) || 
                            rawUrl.startsWith(window.location.origin);
        return {
            previousUrl: isUrlSegura ? rawUrl : '/formularios/responder'
        };
    },
    computed: {
        logoSrc() {
            return getComputedStyle(document.documentElement).getPropertyValue('--logoUrl').trim();
        }
    }
}
</script>

<style scoped>
    .base-height {
        min-height: calc(100vh - 128px)
    }
    .custom-link {
        color: #007bff;
        text-decoration: none;
    }
    .custom-link:hover {
        text-decoration: underline;
    }
    @media screen and (max-width: 768px) {
        .container {
            padding: 0 1rem;
        }
        .base-height {
            min-height: auto;
        }
        .box-texto {
            margin-top: 0!important
        } 
    }
</style>